import React, { useEffect, useState } from "react";
import { LoaderCircle, X, Check, AlertCircle, Info } from 'lucide-react';
import apiHelper from '../apiHelper.js';

const TestSyncModal = ({ isOpen, onClose, onConfirm, rows, setRows, selectedStock }) => {
    const [isProcessing, setIsProcessing] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [saveMessage, setSaveMessage] = useState({ type: '', text: '' });
    const [allDataFetched, setAllDataFetched] = useState(false);

    // Success SVG icon
    const SuccessIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M7.99967 1.3335C4.32367 1.3335 1.33301 4.32416 1.33301 8.00016C1.33301 11.6762 4.32367 14.6668 7.99967 14.6668C11.6757 14.6668 14.6663 11.6762 14.6663 8.00016C14.6663 4.32416 11.6757 1.3335 7.99967 1.3335ZM7.11631 10.4929C6.86809 10.7411 6.46571 10.7413 6.21722 10.4933L4.66331 8.94278C4.40281 8.68284 4.40228 8.26096 4.66213 8.00037C4.92215 7.73962 5.34435 7.73914 5.60496 7.99929L6.66567 9.05816L9.72367 6.00016C9.98398 5.73985 10.406 5.73985 10.6663 6.00016C10.9267 6.26047 10.9267 6.68252 10.6663 6.94283L7.11631 10.4929Z" fill="#146C43"/>
        </svg>
    );

    // Failed SVG icon
    const FailedIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M7.96834 1.3335C4.30967 1.3335 1.33301 4.32416 1.33301 8.00016C1.33301 11.6762 4.32367 14.6668 7.99967 14.6668C11.6757 14.6668 14.6663 11.6762 14.6663 8.00016C14.6663 4.32416 11.6617 1.3335 7.96834 1.3335ZM8.66634 10.6668C8.66634 11.035 8.36786 11.3335 7.99967 11.3335C7.63148 11.3335 7.33301 11.035 7.33301 10.6668C7.33301 10.2986 7.63148 10.0002 7.99967 10.0002C8.36786 10.0002 8.66634 10.2986 8.66634 10.6668ZM8.66634 8.00016C8.66634 8.36835 8.36786 8.66683 7.99967 8.66683C7.63148 8.66683 7.33301 8.36835 7.33301 8.00016V5.3335C7.33301 4.96531 7.63148 4.66683 7.99967 4.66683C8.36786 4.66683 8.66634 4.96531 8.66634 5.3335V8.00016Z" fill="#B02A37"/>
        </svg>
    );

const fetchProductData = async (row) => {
    try {
        if (row.platform.includes('Lazada')) {
            // Lazada API call - GET request using product_id only
            const response = await apiHelper(
                `lazada/get-product/?item_id=${row.product_id}`,
                "GET"
            );
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.success) {
                const productData = data.data;
                console.log('productData>>>>>>',productData)
                console.log('skuData>>>>>>',productData.skus,row.sku_id?.toString())
                // Find the specific SKU in the skus array using sku_id (which is SkuId from response)
                const skuData = productData.skus?.find(sku => 
                    sku.SkuId?.toString() === row.sku_id?.toString()
                );
                
                if (!skuData) {
                    throw new Error(`SKU ID ${row.sku_id} not found in product ${row.product_id}. Available SkuIds: ${productData.skus?.map(s => s.SkuId).join(', ')}`);
                }
                
                return {
                    verified: true,
                    product_name: productData.attributes?.name || '-',
                    sku_name: skuData.SellerSku || '-', // SellerSku is the SKU name
                    product_price: skuData.price ? `SGD ${skuData.price}` : '-',
                    prioduct_stock: skuData.quantity?.toString() || '0',
                    loading: false,
                    hasError: false
                };
            } else {
                throw new Error(data.message || 'Product not found on Lazada');
            }
        } else if (row.platform.includes('Shopee')) {
            // First API call - Get basic product info
            const response = await apiHelper(
                'shopee/get-product-info/',
                'POST',
                { item_id: row.product_id }
            );
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.status === 'success' && data.data?.valid_items?.length > 0) {
                const productData = data.data.valid_items[0];
                
                // If product has models, we need to fetch them separately
                if (productData.has_model) {
                    // Make another API call to get models/variations
                    const modelsResponse = await apiHelper(
                        'shopee/get-model-list/', // You'll need to create or use existing endpoint
                        'POST',
                        { item_id: row.product_id }
                    );
                    console.log('shopee>>>',modelsResponse)
                    
                    if (!modelsResponse.ok) {
                        throw new Error(`Failed to fetch models: ${modelsResponse.status}`);
                    }
                    
                    const modelsData = await modelsResponse.json();
                    console.log("shoppee models",modelsData)
                    // Find the specific model using sku_id
                    let modelInfo = null;
                    if (modelsData.models && Array.isArray(modelsData.models)) {
                        modelInfo = modelsData.models.find(model => 
                            // model.model_id?.toString() === row.sku_id?.toString() ||
                            model.sku_id?.toString() === row.sku_id?.toString()
                        );
                    }
                    console.log('modelInfo',modelInfo)
                    if (!modelInfo) {
                        throw new Error(`Model ID ${row.sku_id} not found in product ${row.product_id}`);
                    }
                    
                    return {
                        verified: true,
                        product_name: productData.item_name || '-',
                        sku_name: modelInfo.model_name || modelInfo.model_sku || '-',
                        product_price: modelInfo.price_info ? `SGD ${modelInfo.price_info[0].current_price}` : '-',
                        prioduct_stock:modelInfo.stock_info.seller_stock ?  modelInfo.stock_info.seller_stock[0].stock?.toString() : '0',
                        loading: false,
                        hasError: false
                    };
                } else {
                    // Product has no models, use the main product info
                    // For single-variant products, sku_id might be empty or same as product_id
                    return {
                        verified: true,
                        product_name: productData.item_name || '-',
                        sku_name: productData.item_sku || '-',
                        product_price: productData.price_info?.current_price 
                            ? `SGD ${productData.price_info.current_price}` 
                            : '-',
                        prioduct_stock: productData.stock_info?.stock?.toString() || '0',
                        loading: false,
                        hasError: false
                    };
                }
            } else {
                throw new Error(data.message || 'Product not found on Shopee');
            }
        } else if (row.platform.includes('Tiktok') || row.platform.includes('TikTok')) {
            console.log(`Fetching TikTok product: ${row.product_id}`);
            
            // TikTok API call - GET request using product_id only
            const response = await apiHelper(
                `tiktok/products/${row.product_id}/`,
                "GET"
            );
            
            console.log('TikTok API response status:', response.status);
            
            if (!response.ok) {
                const errorText = await response.text();
                console.error('TikTok API error response:', errorText);
                throw new Error(`TikTok API error! status: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('TikTok API data received:', data);
            
            // Check if we got a valid response
            if (!data || typeof data !== 'object') {
                throw new Error('Invalid response from TikTok API');
            }
            
            // Find the specific SKU using sku_id
            let skuData = null;
            
            if (data.skus && Array.isArray(data.skus)) {
                skuData = data.skus.find(sku => 
                    sku.id?.toString() === row.sku_id?.toString()
                );
                
                if (!skuData) {
                    throw new Error(`SKU ID ${row.sku_id} not found in product ${row.product_id}`);
                }
            } else {
                throw new Error('No SKUs found for this TikTok product');
            }
            
            // Extract price and stock
            const price = skuData.price?.sale_price || skuData.price?.tax_exclusive_price;
            const currency = skuData.price?.currency || 'SGD';
            
            let stockQuantity = 0;
            if (skuData.inventory && Array.isArray(skuData.inventory)) {
                stockQuantity = skuData.inventory.reduce((sum, inv) => {
                    return sum + (parseInt(inv.quantity) || 0);
                }, 0);
            }
            
            console.log('TikTok parsed data:', {
                product_name: data.title,
                sku_name: skuData.seller_sku,
                price: price ? `${currency} ${price}` : '-',
                stock: stockQuantity
            });
            
            return {
                verified: true,
                product_name: data.title || '-',
                sku_name: skuData.seller_sku || '-',
                product_price: price ? `${currency} ${price}` : '-',
                prioduct_stock: stockQuantity.toString(),
                loading: false,
                hasError: false
            };
        } else {
            throw new Error('Unknown platform');
        }
        
    } catch (error) {
        console.error(`Error fetching data for ${row.platform}:`, error);
        console.error('Row data:', row);
        
        return {
            verified: false,
            product_name: 'Invalid ID',
            sku_name: 'Invalid ID',
            product_price: '-',
            prioduct_stock: '-',
            loading: false,
            hasError: true,
            errorMessage: error.message
        };
    }
};

    // Helper function to safely parse numeric values
    const parsePrice = (priceString) => {
        if (!priceString || priceString === '-' || priceString === 'Invalid ID') {
            return null;
        }
        
        try {
            // Remove currency symbol and any non-numeric characters except decimal point
            const numericString = priceString.replace(/[^\d.-]/g, '');
            const parsed = parseFloat(numericString);
            
            // Return null if parsing results in NaN
            return isNaN(parsed) ? null : parsed;
        } catch (error) {
            console.error('Error parsing price:', error);
            return null;
        }
    };

    // Helper function to safely parse stock quantity
    const parseStockQuantity = (stockString) => {
        if (!stockString || stockString === '-' || stockString === 'Invalid ID') {
            return 0;
        }
        
        try {
            // Remove any non-numeric characters
            const numericString = stockString.replace(/[^\d]/g, '');
            const parsed = parseInt(numericString, 10);
            
            // Return 0 if parsing results in NaN
            return isNaN(parsed) ? 0 : parsed;
        } catch (error) {
            console.error('Error parsing stock quantity:', error);
            return 0;
        }
    };

    const saveTestResults = async (fetchedRows) => {
        if (!selectedStock || !selectedStock.id) {
            console.error('No stock selected or stock ID not available');
            // setSaveMessage({ 
            //     type: 'error', 
            //     text: 'Cannot save test results: No stock selected. Please select a stock first.' 
            // });
            return false;
        }
        
        setIsSaving(true);
        // setSaveMessage({ type: '', text: '' });
        
        try {
            // Filter rows that have platform, product_id, and sku_id
            const validRows = fetchedRows.filter(row => 
                row.platform && row.product_id && row.sku_id
            );
            
            if (validRows.length === 0) {
                // setSaveMessage({ 
                //     type: 'warning', 
                //     text: 'No valid platform mappings to save' 
                // });
                setIsSaving(false);
                return false;
            }
            
            // Prepare data for saving with safe parsing
            const platformMappings = validRows.map(row => {
                const mappingData = {
                    platform: row.platform,
                    product_id: row.product_id,
                    sku_id: row.sku_id,
                    platform_product_name: row.product_name || '',
                    platform_sku_name: row.sku_name || '',
                    test_status: row.hasError ? 'failed' : 'success',
                    error_message: row.errorMessage || (row.hasError ? 'Invalid ID or API error' : '')
                };
                
                // Safely parse price if available
                if (row.product_price && row.product_price !== '-' && row.product_price !== 'Invalid ID') {
                    const parsedPrice = parsePrice(row.product_price);
                    if (parsedPrice !== null) {
                        mappingData.platform_price = parsedPrice;
                    }
                }
                
                // Safely parse stock quantity if available
                if (row.prioduct_stock && row.prioduct_stock !== '-' && row.prioduct_stock !== 'Invalid ID') {
                    const parsedStock = parseStockQuantity(row.prioduct_stock);
                    mappingData.platform_stock_quantity = parsedStock;
                } else {
                    mappingData.platform_stock_quantity = 0;
                }
                
                return mappingData;
            });
            
            const payload = {
                stock_id: selectedStock.id,
                platform_mappings: platformMappings
            };
            
            console.log('Saving test results with payload:', payload);
            
            const response = await apiHelper(
                'sales/test-sync/save/',
                'POST',
                payload
            );
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to save test results');
            }
            
            const result = await response.json();
            console.log('Test results saved:', result);
            
            // setSaveMessage({ 
            //     type: 'success', 
            //     text: `Successfully saved ${result.results?.length || validRows.length} test results` 
            // });
            
            return true;
            
        } catch (error) {
            console.error('Error saving test results:', error);
            // setSaveMessage({ 
            //     type: 'error', 
            //     text: error.message || 'Failed to save test results. Data will not be persisted.' 
            // });
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        if (!isOpen) return;
        
        // Reset states when modal opens
        // setSaveMessage({ type: '', text: '' });
        setAllDataFetched(false);
        setIsProcessing(true);
        
        // Set all rows to loading state
        setRows(prev =>
            prev.map(row => ({
                ...row,
                loading: true,
                verified: false,
                hasError: false,
                product_name: '',
                sku_name: '',
                product_price: '',
                prioduct_stock: ''
            }))
        );

        // Fetch data for all rows
        const fetchAllData = async () => {
            const updatedRows = [];
            
            for (const row of rows) {
                // Only fetch for rows with platform, product_id, and sku_id
                if (row.platform && row.product_id && row.sku_id) {
                    try {
                        const result = await fetchProductData(row);
                        updatedRows.push({
                            ...row,
                            ...result
                        });
                    } catch (error) {
                        updatedRows.push({
                            ...row,
                            loading: false,
                            verified: false,
                            hasError: true,
                            product_name: 'API Error',
                            sku_name: 'API Error',
                            product_price: '-',
                            prioduct_stock: '-',
                            errorMessage: error.message
                        });
                    }
                } else {
                    // For rows without required data
                    updatedRows.push({
                        ...row,
                        loading: false,
                        verified: false,
                        hasError: true,
                        product_name: 'Invalid ID',
                        sku_name: 'Invalid ID',
                        product_price: '-',
                        prioduct_stock: '-',
                        errorMessage: 'Missing required fields: platform, product_id, or sku_id'
                    });
                }
            }
            
            // Update all rows at once
            setRows(updatedRows);
            setIsProcessing(false);
            setAllDataFetched(true);
            
            // Automatically save test results after all data is fetched
            if (updatedRows.length > 0) {
                setTimeout(() => {
                    saveTestResults(updatedRows);
                }, 500); // Small delay to ensure UI updates first
            }
        };

        fetchAllData();

    }, [isOpen]);

    const handleDoneClick = () => {
        onConfirm();
    };

    if (!isOpen) return null;

    return (
        <>
            <div
                className="drawer-overlay"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1040,
                }}
                onClick={onClose}
            />
            <div
                className="entity-drawer modal-popup-cls"
                style={{
                    maxWidth: 872,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                }}
            >
                {/* Header */}
                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                {/* Title */}
                <h3
                    style={{
                        textAlign: "left",
                        color: "#212529",
                        fontSize: "20px",
                        fontWeight: "600",
                        lineHeight: "24px",
                        fontFamily: "Montserrat",
                        marginBottom: "20px",
                    }}
                >
                    Test Sync
                </h3>

                {/* Save Message */}
                {/* {saveMessage.text && (
                    <div 
                        className={`alert ${saveMessage.type === 'success' ? 'alert-success' : saveMessage.type === 'warning' ? 'alert-warning' : 'alert-danger'}`}
                        style={{
                            marginBottom: '15px',
                            padding: '10px 15px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px'
                        }}
                    >
                        {saveMessage.type === 'success' ? <Check size={16} /> : <AlertCircle size={16} />}
                        {saveMessage.text}
                    </div>
                )}

                {!saveMessage.text && allDataFetched && !isSaving && (
                    <div 
                        className="alert alert-info"
                        style={{
                            marginBottom: '15px',
                            padding: '10px 15px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px'
                        }}
                    >
                        <Info size={16} />
                        Test results are being saved automatically...
                    </div>
                )} */}

                {/* Description */}
                <div className="new-look">
                    <div className="entities-tab test-sync" style={{ padding: 0 }}>
                        <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                            <table className="entities-table tab-table w-100">
                                <thead height="45px">
                                    <tr>
                                        <th><span>Platform</span></th>
                                        <th><span>Product Name</span></th>
                                        <th><span>SKU Name</span></th>
                                        <th><span>Product Price</span></th>
                                        <th><span>Product Stock</span></th>
                                        <th><span>Status</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((r, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                {r.loading ? (
                                                    <LoaderCircle className="loading" size={16} style={{ animation: 'spin 1s linear infinite' }} />
                                                ) : r.verified && !r.hasError ? (
                                                    <SuccessIcon />
                                                ) : r.hasError ? (
                                                    <FailedIcon />
                                                ) : null}
                                                &nbsp;&nbsp;
                                                {r.platform || 'No platform selected'}
                                            </td>
                                            <td style={{ color: r.hasError ? '#DC3545' : 'inherit' }}>
                                                {r.product_name}
                                            </td>
                                            <td style={{ color: r.hasError ? '#DC3545' : 'inherit' }}>
                                                {r.sku_name}
                                            </td>
                                            <td>{r.product_price}</td>
                                            <td>{r.prioduct_stock}</td>
                                            <td>
                                                {r.loading ? (
                                                    <span style={{ color: '#6C757D', fontSize: '12px' }}>Fetching...</span>
                                                ) : r.hasError ? (
                                                    <span style={{ color: '#DC3545', fontSize: '12px' }}>Failed</span>
                                                ) : (
                                                    <span style={{ color: '#146C43', fontSize: '12px' }}>Verified</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="drawer-footer" style={{ paddingTop: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontSize: '12px', color: '#6C757D' }}>
                        {rows.filter(r => !r.hasError && r.verified).length} of {rows.length} mappings verified
                        {isSaving && ' • Saving...'}
                    </div>
                    <button 
                        className="btn-save" 
                        onClick={handleDoneClick}
                        disabled={isProcessing}
                        style={{ 
                            opacity: isProcessing ? 0.6 : 1,
                            cursor: isProcessing ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isProcessing ? 'Processing...' : 'Done'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default TestSyncModal;